// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Info_wrapper__1cEn7","header":"Info_header__ULrlh","content":"Info_content__PGWbv"};